import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Request from './Request';
export const PRINT_PRECONFIG_IDS = {
  entireChart: 'entireChart',
  planOfCare: 'planOfCare',
  idgComponents: 'idgComponents'
};
export class ConfigService extends Request {
  constructor({
    url,
    keycloak,
    agency
  }) {
    super({
      url,
      keycloak
    });

    _defineProperty(this, "agency", void 0);

    _defineProperty(this, "listPrintPreconfigs", () => this.get({
      api: '/api/print-preconfigs',
      qs: {
        agency: this.agency
      }
    }));

    _defineProperty(this, "putPrintPreconfig", (id, widgets) => this.post({
      api: `/api/print-preconfigs/${id}`,
      method: 'PUT',
      qs: {
        agency: this.agency
      },
      data: {
        widgets
      }
    }));

    this.agency = agency;
    this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
  }

}
export default ConfigService;